import axios from "../plugins/parseAxios"
export class ContractSuspendAPI {

    static getContractSuspendByContract(payload) {
        return axios.post("functions/getContractSuspendByContract", payload)
    }
    static createContractSuspend(payload) {
        return axios.post("functions/createContractSuspend", payload)
    }
    static getContractSuspend(payload) {
        return axios.post("functions/getContractSuspend", payload)
    }
    static removeContractSuspend(payload) {
        return axios.post("functions/removeContractSuspend", payload)
    }
    static removedContractSuspend(payload) {
        return axios.post("functions/removedContractSuspend", payload)
    }
    static editContractSuspend(payload) {
        return axios.post("functions/editContractSuspend", payload)
    }
    static getContractSuspendBetweenDateByMarket(payload) {
        return axios.post("functions/getContractSuspendBetweenDateByMarket", payload)
    }
}